










































































































import ExportToForm from './components/ExportToForm.vue';
import StudentAttachmentList from './components/studentInformation/StudentAttachmentList.vue'
import StudentEnglishScoreList from './components/studentInformation/StudentEnglishScoreList.vue';
import AgentContact from './components/studentApplicationInformation/AgentContact.vue';
import StudentApplicationDetailBase from './components/studentInformation/StudentApplicationDetailBase.vue';
import StudentApplicationDetailList from './components/studentInformation/StudentApplicationDetailList.vue';
import StudentCourseApplicationBase from './components/studentInformation/StudentCourseApplicationBase.vue';
import StudentCourseApplicationList from './components/studentInformation/StudentCourseApplicationList.vue';
import WorkExperience from './components/studentApplicationInformation/WorkExperience.vue';
import StudentContact from './components/studentApplicationInformation/StudentContact.vue';
import StudentReferrer from './components/studentApplicationInformation/StudentReferrer.vue';
import PersonalProfile from './components/studentApplicationInformation/PersonalProfile.vue';
import GuardiansContact from './components/studentApplicationInformation/GuardiansContact.vue';
import FurtherInformation from './components/studentApplicationInformation/FurtherInformation.vue';
import EducationBackground from './components/studentApplicationInformation/EducationBackground.vue';
import ProfessionalQualification from './components/studentApplicationInformation/ProfessionalQualification.vue';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { getGearStudentApplyApi, getGearStudentApplyDetailApi, getGearStudentApplyFileListApi } from '@/api/index';

@Component({
  name: 'studentInformation',
  components: {
    ExportToForm,
    AgentContact,
    WorkExperience,
    StudentContact,
    PersonalProfile,
    StudentReferrer,
    GuardiansContact,
    FurtherInformation,
    EducationBackground,
    StudentAttachmentList,
    StudentEnglishScoreList,
    ProfessionalQualification,
    StudentApplicationDetailBase,
    StudentApplicationDetailList,
    StudentCourseApplicationBase,
    StudentCourseApplicationList,
  }
})
export default class extends Vue {
  public studentData: any = null;
  public studentApplyDetail: any = null;
  public activeName: string = 'courseApply';
  public applyInfoActiveName: string = 'personalProfile';

  @Watch('$route', { deep: true })
  public onRouteChange(route: any) {
    if (route.params.id && route.name === 'studentInformation') {
      this.getGearStudentApply();
    }
  }

  public mounted() {
    this.getGearStudentApply();
  }

  public handleTabClick(tabNode: any) {
    const tabName = tabNode.name;
    if (tabName === 'applyDetail' && this.studentData.studentInstitutionCourseDtos.length) {
      const currentApplyDetailId = this.studentData.studentInstitutionCourseDtos[0].id;
      this.getGearStudentApplyDetail(currentApplyDetailId);
    } else if (tabName === 'applyContentForm') {
      // 导出表单
      (this.$refs.exportFormRef as any).exportForm();
    }
  }

  public scrollToBlock(block: string) {
    let node: any = this.$refs[block];
    node = node instanceof HTMLElement ? node : node.$el;
    (node).scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }

  public handleCourseApplyListRowClick(data: any) {
    this.activeName = 'applyDetail';
    this.getGearStudentApplyDetail(data.id);
  }

  public async getGearStudentApplyDetail(itemId: string | number) {
    const params = {
      itemId: itemId as number,
      fkStudentId: this.$route.params.id as string,
      stuSource: this.$route.query.source as string
    }
    const { data } = await getGearStudentApplyDetailApi(params);
    this.studentApplyDetail = data.data;
  }

  public async getGearStudentApply() {
    const fkStudentId = this.$route.params.id as string;
    const stuSource = this.$route.query.source as string;
    const itemId = this.$route.query.itemId as string;
    const { data } = await getGearStudentApplyApi({ stuSource, fkStudentId });
    this.studentData = data.data;
    // const studentDto = this.studentData.studentDto;
    // this.$route.meta.title = `${this.$t('route.studentQuery')}-${studentDto.lastName} ${studentDto.firstName}`;
    const tab =  sessionStorage.getItem('tab');
    if (tab) {
      sessionStorage.removeItem('tab');
      if (tab === 'applyDetail') {
        this.handleCourseApplyListRowClick({ id: itemId });
      } else if (tab === 'courseApply') {
        this.activeName = 'courseApply';
      }
    }
  }

  public async updateAttachmentList() {
    const fkStudentId = this.$route.params.id as string;
    const stuSource = this.$route.query.source as string;
    const params = {
      fkStudentId,
      stuSource
    }
    const { data } = await getGearStudentApplyFileListApi(params);
    this.studentData.fileDtos = data.data;
  }
}
